import React, {createContext, Dispatch, useContext, useReducer} from "react"
import CultureHubReducer, {Action, initialState, State} from "./reducer"

type CultureHubContextType = {
  state: State
  dispatch: Dispatch<Action>
}

const CultureHubContext = createContext<CultureHubContextType | undefined>(undefined)

export const CultureHubProvider = ({children}) => {
  const [state, dispatch] = useReducer(CultureHubReducer, initialState)

  return <CultureHubContext.Provider value={{state, dispatch}}>{children}</CultureHubContext.Provider>
}

export const useCultureHubStore = () => {
  const context = useContext(CultureHubContext)
  if (!context) {
    throw new Error("useCultureHubStore must be used within a GlobalProvider")
  }
  return context
}
